module.exports = __webpack_public_path__ + "static/media/050-email-3.7ed724e5.svg";